// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"37efb6da","236":"55e296e1","315":"e7ff91f9","320":"9c31f9bb","437":"210174d8","544":"48ddcfd5","558":"2be16ebb","573":"2e7668d1","586":"66d95e92","631":"e367c3c3","695":"58012fb2","794":"c2634b41"}[chunkId] + ".chunk.js";
};